import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

export interface ListFilterState {
  search: string;
  hideShared: boolean;
}

@Component({
    standalone: true,
    selector: 'app-list-filter-toolbar',
    imports: [FormsModule, SharedModule],
    templateUrl: './list-filter-toolbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./list-filter-toolbar.component.scss']
})
export class ListFilterToolbarComponent {
  @Input() searchPlaceholder = 'Search';
  @Input() hideSharedLabel = 'Hide shared';
  @Input() set resetTrigger(tick: number) {
    if (tick > 0) this.reset();
  }
  @Output() filterChange = new EventEmitter<ListFilterState>();

  search = '';
  hideShared = false;

  reset(): void {
    this.search = '';
    this.hideShared = false;
  }

  onSearchInput(): void {
    this.emitState();
  }

  toggleHideShared(): void {
    this.hideShared = !this.hideShared;
    this.emitState();
  }

  private emitState(): void {
    this.filterChange.emit({ search: this.search, hideShared: this.hideShared });
  }
}
